import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  keepKiddush2,
  sendKiddush2,
  keepShlishit2,
  sendShlishit2,
  keepName,
  loadUsers,
  saveUser,
} from "../store/actions/userAction";
//import "./styles.css";
import ReactCalendar from "react-calendar";
import styled from "styled-components";
import Hebcal, { HDate } from "hebcal";
import gematriya from "gematriya";
import { Button, Input } from "reactstrap";
import { TextField } from "@material-ui/core";
import moment from "moment";

export function GestionEcran() {
  const dispatch = useDispatch();
  const [openFlag, setOpenFlag] = useState(parseInt(0));
  const [data, setData] = useState([]);
  const [dateU, setDateU] = useState("");
  const [Ev, setEv] = useState("");
  const [bol, setBol] = useState(false);
  const [bol2, setBol2] = useState(false);
  const [haftara, setHaftara] = useState("");

  //let bol = false;
  const [focusIdx, setFocusIdx] = useState(0);
  const [titleDvar, setTitleDvar] = useState("");
  const [signature, setSignature] = useState("");
  const [dvar, setDvar] = useState("");
  const [chiour, setChiour] = useState("");
  const [zmanTefilah, setZmanTefilah] = useState("");
  const [subTitleDvar, setSubTitleDvar] = useState("");
  const [mailTemplates, setMailTemplates] = useState([]);
  const [mailTemplateName, setMailTemplateName] = useState("");
  const [mailTemplateSubject, setMailTemplateSubject] = useState("");
  const [mailTemplateBody, setMailTemplateBody] = useState("");
  const [mailTemplateIdx, setMailTemplateIdx] = useState(null);

  const loggedInUser = useSelector((state) => state.userReducer.loggedInUser);
  const users = useSelector((state) => state.userReducer.users);
  // setOpenFlag(0);
  useEffect(async () => {
    // setOpenFlag(0);

    if (loggedInUser.isManager) {
      await dispatch(loadUsers());

      users.map((user) => {
        if (user.isAdmin) {
          setEv(user);
          setTitleDvar(user.titleDvar);
          setSubTitleDvar(user.subTitleDvar);
          setDvar(user.dvar);
          setChiour(user.chiour);
          setSignature(user.signature);
          setZmanTefilah(user.zmanTefilah);
          setMailTemplates(user.mailTemplates || []);
        }
      });
    }
  }, []);

  const submit = () => {
    // console.log("costumerLastName", costumerLastName);
    Ev.titleDvar = titleDvar;
    Ev.signature = signature;
    Ev.dvar = dvar;
    Ev.subTitleDvar = subTitleDvar;
    Ev.zmanTefilah = zmanTefilah;
    Ev.chiour = chiour;
    Ev.mailTemplates = mailTemplates;
    dispatch(saveUser(Ev));
    window.location.assign("/#/");
  };

  const onChangeFocus = (ev) => {
    const { name } = ev.target;
    // console.log(ev);

    setFocusIdx(1);
  };
  const onHandleInputChange = (ev) => {
    const { name, value } = ev.target;
    //  console.log(name, value);

    switch (name) {
      case "titleDvar":
        setTitleDvar(value);
        break;
      case "subTitleDvar":
        setSubTitleDvar(value);
        break;
      case "dvar":
        setDvar(value);
        break;
      case "signature":
        setSignature(value);
        break;
      case "chiour":
        setChiour(value);
        break;
      case "zmanTefilah":
        setZmanTefilah(value);
        break;
      case "mailTemplateName":
        setMailTemplateName(value);
        break;
      case "mailTemplateSubject":
        setMailTemplateSubject(value);
        break;
      case "mailTemplateBody":
        setMailTemplateBody(value);
        break;
      default:
        break;
    }
  };
  const resetMailTemplateForm = () => {
    setMailTemplateName("");
    setMailTemplateSubject("");
    setMailTemplateBody("");
    setMailTemplateIdx(null);
  };

  const saveMailTemplate = () => {
    if (!mailTemplateName.trim()) {
      alert("Merci de donner un nom au template");
      return;
    }

    const newTemplate = {
      name: mailTemplateName,
      subject: mailTemplateSubject,
      body: mailTemplateBody,
    };

    if (mailTemplateIdx !== null) {
      const updated = [...mailTemplates];
      updated[mailTemplateIdx] = newTemplate;
      setMailTemplates(updated);
    } else {
      setMailTemplates([...mailTemplates, newTemplate]);
    }

    resetMailTemplateForm();
  };

  const editMailTemplate = (idx) => {
    const template = mailTemplates[idx];
    setMailTemplateName(template.name || "");
    setMailTemplateSubject(template.subject || "");
    setMailTemplateBody(template.body || "");
    setMailTemplateIdx(idx);
  };

  const deleteMailTemplate = (idx) => {
    if (!window.confirm("Supprimer ce template ?")) return;
    setMailTemplates(mailTemplates.filter((template, index) => index !== idx));
    resetMailTemplateForm();
  };
  //function App() {
  return (
    <div>
      <div>
        <div>
          <p>
            <br></br>
          </p>
          <TextField
            id="outlined-input"
            label="titre Dvar"
            name="titleDvar"
            style={{
              width: 800,
            }}
            onChange={onHandleInputChange}
            defaultValue={titleDvar}
            value={titleDvar}
            multiline
            rows={3}
            InputProps={{
              readOnly: false,
            }}
          />

          <TextField
            id="outlined-input"
            label="URL de paiement"
            name="subTitleDvar"
            defaultValue={subTitleDvar}
            value={subTitleDvar}
            style={{
              width: 800,
            }}
            onChange={onHandleInputChange}
            multiline
            rows={3}
            InputProps={{
              readOnly: false,
            }}
          />
          <p>
            <br></br>
          </p>
          <TextField
            id="outlined-input"
            label="Dvar"
            name="dvar"
            fullWidth
            defaultValue={dvar}
            onChange={onHandleInputChange}
            value={dvar}
            multiline
            rows={15}
            InputProps={{
              readOnly: false,
            }}
          />
          <p>
            <br></br>
          </p>
          <TextField
            id="outlined-input"
            label="Signature"
            name="signature"
            defaultValue={signature}
            onChange={onHandleInputChange}
            value={signature}
            multiline
            rows={2}
            InputProps={{
              readOnly: false,
            }}
          />
          <p>
            <br></br>
          </p>
          <TextField
            id="outlined-input"
            label="horaires des cours"
            name="chiour"
            defaultValue={chiour}
            style={{
              width: 800,
            }}
            onChange={onHandleInputChange}
            value={chiour}
            multiline
            columns={1}
            rows={5}
            InputProps={{
              readOnly: false,
            }}
          />

          <TextField
            id="outlined-input"
            label="horaires des tefilot"
            name="zmanTefilah"
            defaultValue={zmanTefilah}
            onChange={onHandleInputChange}
            value={zmanTefilah}
            style={{
              width: 800,
            }}
            multiline
            rows={5}
            InputProps={{
              readOnly: false,
            }}
          />
          <p>
            <br></br>
          </p>
          <h3>Templates emails</h3>

          <p>
            Variables disponibles : {"{{userFirstName}}"}, {"{{crmFirstName}}"},{" "}
            {"{{crmLastName}}"}, {"{{soldDeb}}"}, {"{{siteAdresse}}"}
          </p>
          <select
            value={mailTemplateIdx !== null ? mailTemplateIdx : ""}
            onChange={(ev) => {
              if (ev.target.value === "") {
                resetMailTemplateForm();
              } else {
                editMailTemplate(Number(ev.target.value));
              }
            }}
            style={{ width: 800, height: 40 }}
          >
            <option value="">Créer un nouveau template</option>
            {mailTemplates.map((template, idx) => (
              <option key={idx} value={idx}>
                {template.name}
              </option>
            ))}
          </select>

          <p>
            <br />
          </p>
          <TextField
            label="Nom du template"
            name="mailTemplateName"
            value={mailTemplateName}
            onChange={onHandleInputChange}
            style={{ width: 800 }}
          />

          <p>
            <br />
          </p>

          <TextField
            label="Sujet du mail"
            name="mailTemplateSubject"
            value={mailTemplateSubject}
            onChange={onHandleInputChange}
            style={{ width: 800 }}
          />

          <p>
            <br />
          </p>

          <TextField
            label="Corps du mail"
            name="mailTemplateBody"
            value={mailTemplateBody}
            onChange={onHandleInputChange}
            style={{ width: 800 }}
            multiline
            rows={10}
          />

          <p>
            <br />
          </p>

          <Button color="primary" onClick={saveMailTemplate}>
            {mailTemplateIdx !== null
              ? "Modifier le template"
              : "Ajouter le template"}
          </Button>

          <Button color="secondary" onClick={resetMailTemplateForm}>
            Annuler
          </Button>
          {mailTemplateIdx !== null && (
            <Button
              color="danger"
              onClick={() => deleteMailTemplate(mailTemplateIdx)}
            >
              Supprimer le template
            </Button>
          )}

          <p>
            <br />
          </p>
          <Button
            className="save-btn btn-simple animation-on-hover"
            color="success"
            variant="contained"
            onClick={() => {
              submit();
            }}
          >
            sauvegarder
          </Button>
        </div>
      </div>
    </div>
  );
}

// const rootElement = document.getElementById("root");
// ReactDOM.render(<App />, rootElement);
